export default __webpack_public_path__ + "static/media/logo-white.ba35dc7d.svg";